<template>
  <div class="container">
    <!-- <public-search @childBySearch="childBySearch"></public-search> -->
    <section class="article-search">
      <div class="search-wapper">
        <!-- 添加加载状态判断，等待sysName获取完成 -->
        <h3>
          <span>•</span>{{ !sysName || sysName === "null" ? "外文学术资源数据库" : sysName }}
          <span>•</span>
        </h3>
        <!-- <h3 v-else><span>•</span> 外文学术资源数据库<span>•</span></h3> -->
        <div class="search flex">
          <div>
            <div class="flex search_div">
              <!-- <el-select v-model="search.value" class="title-select" placeholder="请选择">
                <el-option
                  v-for="item in search.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select> -->
              <div class="searchLeft flex">
                <el-select v-model="search.selectVal" v-if="search.value == 1" placeholder="请选择">
                  <el-option v-for="item in search.searchPaperOptions" :key="item.label" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <div class="inputDiv flex">
                  <el-input v-model="search.keyword" clearable @keyup.enter.native="toSearch" :placeholder="placeholderName()" @input="getKeywordData" @focus="showSearchInput" @blur="hideSearchInput"></el-input>
                  <img src="../../assets/images/search.png" @click="toSearch" />
                </div>
                <div class="search-lianxiang" v-if="searchFlag" @click.stop>
                  <ul>
                    <li class="line1" v-for="(item, index) in keywordDataList" :key="index" @click="toSearchKeyword(index)" v-html="item.suggestionWord"></li>
                  </ul>
                </div>
              </div>
              <a @click="toHightSearch">高级检索</a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="w1200 flex">
      <div v-if="loading && leftData.length === 0" class="journal-filter-skeleton" aria-label="期刊筛选条件加载中">
        <div v-for="group in 3" :key="group" class="filter-skeleton-group">
          <span class="skeleton-line filter-title"></span>
          <span v-for="line in 5" :key="line" class="skeleton-line filter-line"></span>
        </div>
      </div>
      <left-menu v-show="leftData.length > 0" :leftData="leftData" :showLetterFlag="showLetter" :delName="delName" :delSourceFrom="delSource" :delAll="delAll" @childByValue="childByValue" @sourceByValue="sourceByValue"></left-menu>
      <!-- 右侧列表 -->
      <div class="right-list">
        <div class="right-top">
          <p class="filter">
            <span class="searchword" v-if="searchWord">
              检索条件："<label>{{ searchWord }}</label
              >"
            </span>
            <span class="searchword" v-if="!searchWord && searchArray.length > 0">
              高级检索条件："
              <label v-for="(item, index) in searchArray" :key="index">{{ item.searchField == "name" ? "刊名" : item.searchField == "publisherName" ? "出版社" : "ISSN" }}：{{ item.searchWords }}{{ index + 1 < searchArray.length ? "," : "" }} </label>"
            </span>
            筛选条件：
            <label v-for="(item, index) in sourceList" :key="index" class="flex">
              资源来源:
              {{ item == 1 ? "加入馆外资源更多结果" : "开放获取资源" }}
              <i class="el-icon-close" @click="delSource = item"></i>
            </label>
            <label v-for="(item, index) in conData" :key="index" class="flex">
              {{ item.fatherName }}: {{ item.name }}
              <i class="el-icon-close" @click="delName = item"></i>
            </label>
            <label v-if="hasActiveFilters" class="clear-all flex" @click="clearAllFilters">
              清空全部
              <i class="el-icon-close"></i>
            </label>
          </p>
          <div class="total">
            <label>{{ listTotal }}</label
            >条记录
            <!-- <p>
              排序：
              <el-select v-model="sortVal" @change="handleSearchSort" placeholder="请选择">
                <el-option v-for="item in sortList" :key="item.label" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </p> -->
            <div class="pagination-controls">
              <button class="page-btn prev-btn" @click="handlePrevPage" :disabled="pageNo <= 1">
                <i class="el-icon-arrow-left"></i>
              </button>
              <span class="page-info">{{ pageNo }}/{{ Math.ceil(total / pageSize) }}</span>
              <button class="page-btn next-btn" @click="handleNextPage" :disabled="pageNo >= Math.ceil(total / pageSize)">
                <i class="el-icon-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="right-item">
          <ul v-if="loading" class="journal-list-skeleton" aria-label="期刊列表加载中">
            <li v-for="item in 5" :key="item" class="journal-skeleton-item">
              <span class="skeleton-line skeleton-index"></span>
              <span class="skeleton-line skeleton-cover"></span>
              <div class="skeleton-content">
                <span class="skeleton-line skeleton-title"></span>
                <span class="skeleton-line skeleton-meta skeleton-meta-short"></span>
                <span class="skeleton-line skeleton-meta"></span>
                <span class="skeleton-line skeleton-meta skeleton-meta-medium"></span>
                <span class="skeleton-line skeleton-score"></span>
              </div>
            </li>
          </ul>
          <ul v-else>
            <li class="flex" v-for="(item, index) in list" :key="index" :data-home-sid="item.sid">
              <span class="index">{{ (pageNo - 1) * pageSize + index + 1 }}</span>
              <div class="img" @click="toDetail(item.sid)">
                <img :src="item.cover ? imgUrl + item.cover : defaultImg" />
              </div>
              <div class="right-info">
                <p v-if="item.name" @click="toDetail(item.sid)">
                  <span v-html="item.name"></span>
                  <!-- oa去除馆藏标识 -->
                  <!-- <img v-if="item.isLibrary == 1 && pzType != 'oa'" src="../../assets/images/icon-gc.png" /> -->
                </p>

                <p v-if="item.issn">ISSN：<span v-html="item.issn"></span></p>
                <p v-if="item.aliasName">其他刊名：<span v-html="item.aliasName"></span></p>
                <!-- <p v-if="item.pissn">PISSN: <span v-html="item.pissn"></span></p>
                <p v-if="item.eissn">EISSN: <span v-html="item.eissn"></span></p> -->
                <p v-if="item.publisherName">出版社：<span v-html="item.publisherName"></span></p>
                <p class="yinzi" v-if="item.effectScore">
                  影响因子：<span>{{ item.effectScore }}</span>
                </p>
              </div>
            </li>
          </ul>
          <div class="noData" v-if="!loading && total <= 0">
            <img src="../../assets/images/noData.png" />
          </div>
          <el-pagination v-if="!loading" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="[10, 20, 30, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" hide-on-single-page> </el-pagination>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import baseurl from "../../api/baseurl";
import PublicSearch from "@/components/public_search.vue";
import LeftMenu from "@/components/leftMenu.vue";
export default {
  name: "home",
  components: { PublicSearch, LeftMenu },
  data() {
    return {
      loading: true,
      conData: [], //条件的过律?
      filterData: [],
      leftData: [],
      showLetter: true,
      delName: null,
      pageSize: 10,
      pageNo: 1,
      listTotal: 0,
      total: 100,
      searchObj: null,
      list: [],
      imgUrl: "",
      defaultImg: require("../../assets/images/default.png"),
      searchWord: "",
      searchArray: [],
      delAll: 0,
      pzType: "",
      sourceList: [],
      delSource: 0,
      search: {
        value: 1,
        options: [
          {
            value: 1,
            label: "分词检索",
          },
          {
            value: 2,
            label: "智能检索",
          },
        ],
        searchPaperOptions: [
          { label: "全部", value: null },
          { label: "刊名", value: "name" },
          { label: "ISSN", value: "issn" },
          { label: "出版社", value: "publisherName" },
        ],
        selectVal: null,
        keyword: "",
      },
      sortList: [
        {
          value: "_score",
          label: "相关度",
        },
        // {
        //   value: "year",
        //   label: "年份",
        // },
      ],
      sortVal: "_score",
      searchFlag: false, // 控制联想词列表显示隐藏
      keywordDataList: [], // 存储联想词数据
      sysName: "",
      itemRestoreTimers: [],
      pendingRestoreSid: "",
    };
  },
  computed: {
    // 检查conData中是否已经有学科筛选条件
    hasSubjectInConData() {
      return this.conData.some(item => item.fatherName === "外文学科" || item.fatherName === "学科" || (item.filterField && item.filterField === "secondSubject"));
    },
    hasActiveFilters() {
      return this.sourceList.length > 0 || (this.preSelectedSubject && this.preSelectedSubject.id && !this.hasSubjectInConData) || this.conData.length > 0;
    },
  },
  mounted() {
    this.imgUrl = baseurl.fileUrl;

    if (sessionStorage.getItem("heightSearchWord")) {
      this.searchArray = JSON.parse(sessionStorage.getItem("heightSearchWord"));
    }
    if (localStorage.getItem("sysName")) {
      this.sysName = localStorage.getItem("sysName");
    } else if (localStorage.getItem("systemName")) {
      this.sysName = localStorage.getItem("systemName");
    }

    this.getList();
  },
  activated() {
    if (sessionStorage.getItem("chongda_skip_restore_once") === this.$route.path) {
      sessionStorage.removeItem("chongda_skip_restore_once");
      sessionStorage.removeItem("chongda_home_should_restore");
      this.$nextTick(() => {
        [0, 80, 180, 400, 800, 1200].forEach(delay => {
          setTimeout(() => {
            this.scrollPageToTop();
            this.resetInnerScrollableElements();
          }, delay);
        });
      });
      return;
    }
    if (sessionStorage.getItem("chongda_home_should_restore") === "1") {
      sessionStorage.removeItem("chongda_home_should_restore");
      this.$nextTick(() => {
        this.restoreSavedAnchorRepeatedly();
      });
    }
  },
  deactivated() {
    this.clearItemRestoreTimers();
  },
  destroyed() {
    this.clearItemRestoreTimers();
    sessionStorage.removeItem("heightSearchWord");
  },
  beforeRouteLeave(to, from, next) {
    this.saveCurrentRestoreAnchor(to.name === "homeDetail" ? this.pendingRestoreSid : "");
    this.pendingRestoreSid = "";
    this.clearItemRestoreTimers();
    next();
  },
  methods: {
    toSearch() {
      this.pageNo = 1;
      this.getList();
    },
    placeholderName() {
      if (this.search.value == 2) {
        return "支持自然语言（语义）检索";
      } else {
        return "请输入刊名、ISSN、出版社";
      }
    },
    getList() {
      let array = [];
      this.filterData.forEach(element => {
        array.push({
          filterField: element.filterField,
          filterValue: element.filterValue,
          type: element.fatherName == "资源来源" ? "metric" : null,
        });
      });

      let postBody = {
        searchWord: this.search.keyword,
        searchFields: this.search.selectVal ? this.search.selectVal.split(",") : [],
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        orderField: this.sortVal,
        orderType: "DESC",
        metricFilterList: array,
        paramList: JSON.parse(sessionStorage.getItem("heightSearchWord")),
        sourceList: this.sourceList.length > 0 ? this.sourceList : [],
      };

      this.$http({
        url: "api/v1/reception/journal/list",
        method: "POST",
        data: postBody,
      }).then(res => {
        this.total = res.data.recordCount > 10000 ? 10000 : res.data.recordCount;
        this.listTotal = res.data.recordCount;
        this.list = res.data.recordList;
        res.data.left.forEach(element => {
          //默认展开 显示全部 否则默认显示5条记录
          if (element.name == "核心期刊" || element.name == "学科分类") {
            element.drop = true;
            element.dropNum = element.items.length;
          } else {
            element.dropNum = 5;
          }
        });
        this.leftData = res.data.left;
        this.delSource = 0;
      }).finally(() => {
        this.loading = false;
      });
    },
    childBySearch(val) {
      sessionStorage.removeItem("heightSearchWord");
      this.delAll++;
      this.conData = [];
      this.filterData = [];
      this.searchArray = [];
      this.searchWord = val.keyword;
      this.searchFields = val.selectVal;
      this.pageNo = 1;
      this.loading = true;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      this.getList();
    },
    childByValue(val) {
      this.pageNo = 1;
      this.conData = val.filterArray;
      this.filterData = val.newNarr;
      this.getList();
    },
    // 资源来源
    sourceByValue(val) {
      this.loading = true;
      this.pageNo = 1;
      this.sourceList = val;
      this.getList();
    },
    clearItemRestoreTimers() {
      this.itemRestoreTimers.forEach(timer => clearTimeout(timer));
      this.itemRestoreTimers = [];
    },
    getScrollTargets() {
      const elements = [
        document.getElementById("subapp-container"),
        document.querySelector(".view"),
        document.scrollingElement,
        document.documentElement,
        document.body,
      ].filter(Boolean);
      return elements.filter((element, index) => elements.indexOf(element) === index);
    },
    scrollPageToTop() {
      this.getScrollTargets().forEach(element => {
        element.scrollTop = 0;
      });
      window.scrollTo(0, 0);
    },
    resetInnerScrollableElements() {
      const nodes = this.$el && this.$el.querySelectorAll ? Array.from(this.$el.querySelectorAll("*")) : [];
      nodes.forEach(element => {
        const style = window.getComputedStyle(element);
        const canScroll = element.scrollHeight > element.clientHeight;
        const allowsScroll = style.overflowY === "auto" || style.overflowY === "scroll" || style.overflowY === "overlay";
        if (canScroll || allowsScroll) {
          element.scrollTop = 0;
        }
      });
    },
    adjustPageScrollBy(delta) {
      if (!delta) {
        return;
      }
      this.getScrollTargets().forEach(element => {
        element.scrollTop += delta;
      });
      window.scrollBy(0, delta);
    },
    getVisibleRestoreItem() {
      const items = this.$el && this.$el.querySelectorAll ? Array.from(this.$el.querySelectorAll("[data-home-sid]")) : [];
      if (!items.length) {
        return null;
      }
      const visibleItem = items.find(item => {
        const rect = item.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < window.innerHeight;
      });
      return visibleItem || items[0];
    },
    saveCurrentRestoreAnchor(preferredSid) {
      let target = null;
      if (preferredSid && this.$el && this.$el.querySelector) {
        target = this.$el.querySelector(`[data-home-sid="${preferredSid}"]`);
      }
      if (!target) {
        target = this.getVisibleRestoreItem();
      }
      if (!target) {
        return;
      }
      const sid = target.getAttribute("data-home-sid");
      const rect = target.getBoundingClientRect();
      sessionStorage.setItem(
        "chongda_home_restore_anchor",
        JSON.stringify({
          sid,
          offsetTop: rect.top,
        })
      );
      sessionStorage.setItem("chongda_home_should_restore", "1");
    },
    restoreSavedAnchorRepeatedly() {
      const anchorText = sessionStorage.getItem("chongda_home_restore_anchor");
      if (!anchorText) {
        return;
      }
      let anchor = null;
      try {
        anchor = JSON.parse(anchorText);
      } catch (error) {
        return;
      }
      if (!anchor || !anchor.sid) {
        return;
      }
      this.clearItemRestoreTimers();
      [0, 80, 180, 320, 500].forEach(delay => {
        const timer = setTimeout(() => {
          const target = this.$el && this.$el.querySelector ? this.$el.querySelector(`[data-home-sid="${anchor.sid}"]`) : null;
          if (target && target.scrollIntoView) {
            target.scrollIntoView({ block: "start", behavior: "auto" });
            const currentTop = target.getBoundingClientRect().top;
            this.adjustPageScrollBy(currentTop - Number(anchor.offsetTop || 0));
          }
        }, delay);
        this.itemRestoreTimers.push(timer);
      });
    },
    toDetail(sid) {
      this.pendingRestoreSid = String(sid);
      this.$router.push({
        path: "/homeDetail",
        query: { sid: sid },
      });
    },
    // 跳转高级检索
    toHightSearch() {
      this.$router.push({ path: "/search", query: { type: "home" } });
    },
    // 排序
    handleSearchSort() {
      this.pageNo = 1;
      this.getList();
    },
    // 上一页
    handlePrevPage() {
      if (this.pageNo > 1) {
        this.pageNo--;
        this.getList();
      }
    },
    // 下一页
    handleNextPage() {
      if (this.pageNo < Math.ceil(this.total / this.pageSize)) {
        this.pageNo++;
        this.getList();
      }
    },

    getKeywordData() {
      // 根据当前激活的tab选择对应的关键词
      if (!this.search.keyword.trim()) {
        this.searchFlag = false;
        return;
      }
      this.$http({
        url: `api/v1/concept/journal/suggestion?word=${this.search.keyword.trim()}`,
        method: "get",
      }).then(res => {
        if (res.code == 200) {
          if (res.data.length == 0) {
            this.searchFlag = false;
          } else {
            this.keywordDataList = res.data;
            this.searchFlag = true;
          }
        }
      });
    },
    // 点击联想关键词事件
    toSearchKeyword(index) {
      sessionStorage.removeItem("subjectSearchKeyword");
      let searchWords = this.keywordDataList[index].suggestionWord.split("<span style='color:#15babc'>").join("").split("</span>").join("");
      this.search.keyword = searchWords;
      this.getList();
    },

    // 控制联想框显示
    showSearchInput() {
      if (this.search.keyword.trim() && this.keywordDataList.length > 0) {
        this.searchFlag = true;
      }
    },
    // 控制联想框隐藏
    hideSearchInput() {
      // 使用setTimeout延迟隐藏，以便点击联想词时能触发点击事件
      setTimeout(() => {
        this.searchFlag = false;
      }, 200);
    },
    clearAllFilters() {
      this.sourceList = [];
      this.conData = [];
      this.filterData = [];
      this.pageNo = 1;
      this.delAll = new Date().getTime();
      this.getList();
      this.$message.success("已清空全部筛选条件");
    },
  },
};
</script>

<style lang="scss" scoped>
.skeleton-line {
  display: block;
  border-radius: 3px;
  background: linear-gradient(90deg, #eef1f5 25%, #f7f8fa 37%, #eef1f5 63%);
  background-size: 400% 100%;
  animation: journal-skeleton-loading 1.4s ease infinite;
}

@keyframes journal-skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

.journal-filter-skeleton {
  width: 250px;
  flex: 0 0 250px;
  margin-right: 20px;

  .filter-skeleton-group {
    padding: 18px 20px;
    margin-bottom: 10px;
    background: #fff;
  }

  .filter-title {
    width: 42%;
    height: 18px;
    margin-bottom: 20px;
  }

  .filter-line {
    width: 100%;
    height: 14px;
    margin-top: 14px;

    &:nth-child(2n) {
      width: 78%;
    }
  }
}

.journal-list-skeleton {
  margin: 0;
  padding: 0;

  .journal-skeleton-item {
    display: flex;
    padding: 20px 0;
    border-bottom: 1px dashed #e8ebef;
  }

  .skeleton-index {
    flex: 0 0 30px;
    width: 30px;
    height: 18px;
    margin: 4px 20px 0 0;
  }

  .skeleton-cover {
    flex: 0 0 160px;
    width: 160px;
    height: 160px;
    margin-right: 20px;
  }

  .skeleton-content {
    flex: 1;
    min-width: 0;
  }

  .skeleton-title {
    width: 46%;
    height: 21px;
    margin-bottom: 20px;
  }

  .skeleton-meta {
    width: 68%;
    height: 14px;
    margin-top: 14px;
  }

  .skeleton-meta-short {
    width: 32%;
  }

  .skeleton-meta-medium {
    width: 52%;
  }

  .skeleton-score {
    width: 120px;
    height: 14px;
    margin-top: 24px;
  }
}

@media (max-width: 1024px) {
  .journal-filter-skeleton {
    width: 100%;
    flex-basis: 100%;
    margin: 0 0 12px;
  }
}

@media (max-width: 768px) {
  .journal-list-skeleton {
    .journal-skeleton-item {
      padding: 16px 0;
    }

    .skeleton-index {
      display: none;
    }

    .skeleton-cover {
      flex-basis: 92px;
      width: 92px;
      height: 120px;
      margin-right: 12px;
    }

    .skeleton-title,
    .skeleton-meta,
    .skeleton-meta-short,
    .skeleton-meta-medium {
      width: 90%;
    }

    .skeleton-score {
      margin-top: 16px;
    }
  }
}

.container {
  width: 100%;
  .article-search {
    width: 100%;
    padding-top: 40px;
    height: 240px;
    background: url("../../assets/images/search_bg.png") no-repeat;
    background-size: 100% 100%;
    .search-wapper {
      width: calc(100% - 40px);
      max-width: 1200px;
      min-width: 0;
      margin: 0 auto;
      position: relative;
      height: 100%;
    }
    h3 {
      text-align: center;
      font-weight: normal;
      font-size: 26px;
      font-family: "宋体";
      span {
        color: #cccccc;
      }
    }
    .search {
      align-items: center;
      justify-content: center;
      .search_div {
        align-items: center;
        margin-top: 30px;
        margin-bottom: 15px;
        a {
          font-size: 18px;
          text-decoration: underline;
          &:hover {
            text-decoration: underline;
          }
        }
        .title-select {
          width: 120px;
          margin-right: 10px;
          ::v-deep .el-input__inner {
            height: 52px;
            border: 1px solid #ccc;
            border-radius: 0;
          }
        }
      }
      .searchLeft {
        border: 1px solid #cccccc;
        width: min(640px, calc(100vw - 380px));
        min-width: 0;
        height: 52px;
        background: #fff;
        position: relative;
        ::v-deep .el-input__inner {
          border: none;
          height: 52px;
          background: none;
          border-radius: 0;
        }
        .el-select {
          position: relative;
          width: 110px;
          &::after {
            content: "";
            position: absolute;
            right: -2px;
            top: 50%;
            margin-top: -12px;
            width: 1px;
            height: 24px;
            background: #cccccc;
            background: #006eb2;
          }
        }
        .inputDiv {
          align-items: center;
          flex: 1;
          background: #fff;
          ::v-deep .el-input {
            flex: 1;
          }
        }
        img {
          width: 22px;
          height: 24px;
          cursor: pointer;
          margin-right: 20px;
        }
      }
      a {
        color: #2d8cf0;
        margin-left: 10px;
      }
    }
    .search_nav {
      color: #999999;
      font-size: 14px;
      position: absolute;
      left: 0;
      bottom: 10px;
    }
    .item {
      padding-left: 15px;
      li {
        display: flex;
        align-items: center;
        margin-right: 30px;
        cursor: pointer;
        color: #666666;
        font-size: 14px;
        img {
          margin-right: 5px;
        }
      }
    }
  }
  .w1200 {
    width: calc(100% - 40px);
    max-width: 1200px;
    min-width: 0;
    min-height: calc(100vh - 444px);
    margin-top: 30px;
    margin-bottom: 30px;
    .right-list {
      flex: 1;
      min-width: 0;
      .right-top {
        background: #fff;
      }
      .filter {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        padding: 15px;
        border-bottom: 1px solid #eeeeee;
        line-height: 29px;
        gap: 10px;
        .searchword {
          margin-right: 20px;
          label {
            color: #2d8cf0;
          }
        }
        .flex {
          display: inline-block;
          border: 1px solid #cccccc;
          color: #2d8cf0;
          font-size: 14px;
          padding: 0 10px;
          height: 30px;
          i {
            margin-left: 5px;
            font-size: 12px;
            color: #999999;
            cursor: pointer;
          }
        }
        .clear-all {
          cursor: pointer;
          margin-right: 10px;
          color: #e40000;
        }
      }
      .total {
        padding: 15px;
        color: #666666;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        label {
          color: #e40000;
          margin: 0 3px;
        }
        p {
          margin-left: auto;
          ::v-deep .el-input__inner {
            width: 140px;
            border: none;
            background: #f7f7f7;
          }
        }
      }
      .right-item {
        background: #fff;
        margin-top: 10px;
        padding: 0 20px;
        ul {
          li {
            padding: 20px 0;
            border-bottom: 1px dashed #eeeeee;
            .index {
              width: 50px;
            }
            .img {
              width: 160px;
              height: 160px;
              display: flex;
              align-items: center;
              justify-content: center;
              overflow: hidden;
              border: 1px solid #eeeeee;
              cursor: pointer;
              margin-right: 20px;
              cursor: pointer;
              img {
                max-width: 158px;
                max-height: 158px;
              }
            }
            .right-info {
              color: #666666;
              flex: 1;
              min-width: 0;
              position: relative;
              p {
                line-height: 25px;
                &:nth-of-type(1) {
                  color: #333;
                  font-size: 18px;
                  font-weight: bold;
                  margin-bottom: 10px;
                  cursor: pointer;
                }
                img {
                  margin-left: 10px;
                  height: 22px;
                  vertical-align: -6px;
                }
              }
              .yinzi {
                position: absolute;
                bottom: 0;
                left: 0;
                font-size: 14px;
                span {
                  color: #45c1c3;
                }
              }
            }
            &:hover {
              .right-info {
                p {
                  &:nth-of-type(1) {
                    background-image: linear-gradient(to right, #006eb3, #2d8cf0);
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    // color: #2d8cf0;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
.total {
  .pagination-controls {
    display: flex;
    align-items: center;
    margin-left: auto;
  }

  .page-btn {
    width: 36px;
    height: 36px;
    border: 1px solid #dcdfe6;
    background-color: #fff;
    color: #606266;
    cursor: pointer;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    margin: 0 4px;
    transition: all 0.3s;
  }

  .page-btn:hover:not(:disabled) {
    color: #2d8cf0;
    border-color: #2d8cf0;
  }

  .page-btn:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .page-info {
    margin: 0 8px;
    color: #606266;
    font-size: 14px;
  }

  /* 修复排序选项的样式，确保它们不会被分页控件挤压 */
  .sort-item > p {
    margin-right: 30px;
    font-size: 16px;
    font-weight: bold;
    display: inline-block;
    cursor: pointer;
    position: relative;
    &:hover {
      color: #2d8cf0;
      &::before {
        content: "";
        position: absolute;
        bottom: -21px;
        left: 50%;
        margin-left: -25px;
        height: 2px;
        width: 50px;
        z-index: 88;
        background: #2d8cf0;
      }
    }
  }
}
.search-lianxiang {
  position: absolute;
  top: 52px;
  margin-left: 0px;
  width: 638px;
  max-height: 300px;
  overflow-y: auto;
  background: white;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  ul {
    margin: 0;
    padding: 0;
    li {
      padding: 6px 16px;
      cursor: pointer;
      transition: background-color 0.2s;
      color: #666;
      font-size: 15px;
      &:hover {
        background-color: #f5f7fa;
      }
    }
  }
}

@media (max-width: 1024px) {
  .container .w1200 {
    flex-direction: column;

    .right-list {
      width: 100%;
    }
  }

  ::v-deep .container_menu {
    width: 100%;
    max-width: none;
    min-height: 0;
    margin-right: 0;
    margin-bottom: 12px;

    .menu .menu-list {
      max-height: 280px;
    }
  }
}

@media (max-width: 768px) {
  .container {
    .article-search {
      height: auto;
      min-height: 210px;
      padding: 24px 0 14px;

      .search-wapper {
        width: calc(100% - 24px);
      }

      h3 {
        font-size: 21px;
        line-height: 1.5;
      }

      .search .search_div {
        align-items: stretch;
        flex-direction: column;
        width: 100%;
        margin-top: 20px;

        > a {
          align-self: flex-end;
          margin: 10px 0 0;
          font-size: 14px;
        }
      }

      .search .searchLeft {
        width: 100%;
        height: 44px;

        ::v-deep .el-input__inner {
          height: 42px;
        }

        .el-select {
          width: 92px;
        }

        img {
          width: 20px;
          height: 21px;
          margin-right: 14px;
        }
      }
    }

    .w1200 {
      width: calc(100% - 24px);
      margin-top: 12px;
      margin-bottom: 16px;

      .right-list {
        .filter {
          align-items: flex-start;
          padding: 12px;

          .flex {
            height: auto;
            min-height: 30px;
            line-height: 22px;
            overflow-wrap: anywhere;
          }
        }

        .total {
          padding: 12px;
          flex-wrap: wrap;
          gap: 10px;
        }

        .right-item {
          padding: 0 12px;

          ul li {
            align-items: flex-start;
            padding: 16px 0;

            .index {
              width: 28px;
              flex: 0 0 28px;
            }

            .img {
              width: 92px;
              height: 120px;
              flex: 0 0 92px;
              margin-right: 12px;

              img {
                max-width: 90px;
                max-height: 118px;
              }
            }

            .right-info p {
              line-height: 22px;
              overflow-wrap: anywhere;

              &:nth-of-type(1) {
                font-size: 16px;
              }
            }

            .right-info .yinzi {
              position: static;
              margin-top: 8px;
            }
          }
        }
      }
    }
  }

  .search-lianxiang {
    top: 44px;
    width: 100%;
  }

  ::v-deep .el-pagination {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px 0;
    white-space: normal;

    .el-pagination__sizes,
    .el-pagination__jump {
      margin-left: 0;
    }
  }
}

@media (max-width: 480px) {
  .container .w1200 .right-list .right-item ul li {
    .index {
      display: none;
    }

    .img {
      width: 76px;
      height: 100px;
      flex-basis: 76px;

      img {
        max-width: 74px;
        max-height: 98px;
      }
    }
  }

  ::v-deep .el-pagination {
    .el-pagination__total,
    .el-pagination__sizes,
    .el-pagination__jump {
      display: none;
    }
  }
}
</style>
